import {Storage} from "@/Services/Storage";

export default {
    name : `requests`,
    state: {
        requests : 0,
        kazangRequests : 0,
        banks: [],
    },
    getters: {
        getTotalRequestCount:(state)=>{
          return state.kazangRequests + state.requests;
        },

        getClientRequestCount:(state)=>{
          return state.requests;
        },

        getAgentRequestCount:(state)=>{
          return state.kazangRequests;
        },

        getAllBanks: (state) => state.banks,
    },
    mutations: {
        setRequestCounts:(state , payload) => {
          state.requests = payload.requestCount;
          state.kazangRequests = payload.agentCount;
        },
        setBanks: (state, banks) => {
          state.banks = banks;
        },
    },
    actions: {
        getRequestCounts:(context)=>{
            let userID = Storage.getAgentID();
            if (!userID) return;
            let currentCount = context.getters.getTotalRequestCount;
            
            return axios.get(bankApi+`bankAgents/countAllRequests?AgentID=`+userID)
                .then(({data}) => {
                    context.commit(`setRequestCounts`, data.response)
                    let updatedCount = context.getters.getTotalRequestCount;
                    return updatedCount > currentCount;
                }).catch(err=>errorHandler.tomcatError(err))
        },
        getAllPendingRequests:() => {
            let userID = Storage.getAgentID();
       

            return axios.get(bankApi+`bankAgents/getAllPending?AgentID=8072789873`)
                .then(({data}) => data.response).catch(err=>errorHandler.tomcatError(err))
        },
        getAllPendingAgentRequests:() => {
            let userID = Storage.getAgentID();
            return axios.get(bankApi+`bankAgents/getAgentSignUpRequests?AgentID=`+userID)
                .then(({data}) => data.response).catch(err=>errorHandler.tomcatError(err))
        },
        getClientDataByID : (context , headerID) =>{
            return axios.get(bankApi+`signup/signupData?id=`+headerID)
                .then(({data})=> data.response)
                .catch(err=>errorHandler.tomcatError(err))
        },
        getAdditionalFields : (context , payload) =>{
            return axios.get(bankApi+`AdditonalData/getbyids?userId=${payload.userId}&BankId=`+payload.bankId)
                .then(({data})=> data[0])
                .catch(err=>errorHandler.tomcatError(err))
        },
        getAgentByID : (context , agentID) =>{
            return axios.get(bankApi+`kazangAgents/getAgentByID?kazangID=`+agentID)
                .then(({data})=> data.response)
                .catch(err=>errorHandler.tomcatError(err))
        },
        getPhotoByID : async (context , imageID) =>{
            if (!imageID) return null;
            try {
                const res = await axios.get(bankApi+`signup/image?id=`+imageID);
                return res.data.response.image;  
            } catch(error) {
                console.error('Error fetching photo:', error);
                errorHandler.tomcatError(error);
                return null;  // Return null on error
            }
        },

        approveRequest : (context , payload) =>{
            return axios.post(bankApi+`Integration/signup/bank/approve`, payload, {
                params: {
                    bankid: payload.bankid,
                }
            })
            .then(()=> {
                context.dispatch(`getRequestCounts`)
                responses.showSuccess(`Request Approved`)
            }).catch(err=>errorHandler.tomcatError(err))
        },

        declineRequest : (context , payload) =>{
            return axios.post(bankApi+`Integration/signup/bank/decline`, payload, {
                params: {
                    bankid: payload.bankid,
                }
            })
            .then(()=>context.dispatch(`getRequestCounts`))
            .catch(err=>errorHandler.tomcatError(err))
        },

        approveKazangAgent : (context , headerID) =>{
            let userID = Storage.getAgentID();
            let object ={
                aprovedUser : userID,
                idAproved : headerID,
            }
            return axios.post(bankApi+`signup/approveKazangAgent`,object)
                .then(()=> {
                    context.dispatch(`getRequestCounts`)
                    responses.showSuccess(`Request Approved`)
                }).catch(err=>errorHandler.tomcatError(err))
        },

        declineKazangAgent : (context , payload) =>{
            let userID = Storage.getAgentID();
            payload = {
                declinedUser : userID,
                ...payload
            }
            return axios.post(bankApi+`signup/declineKazangAgent`,payload)
                .then(()=>context.dispatch(`getRequestCounts`))
                .catch(err=>errorHandler.tomcatError(err))
        },

        getAllAcceptedRequests: () => {
            let userID = Storage.getAgentID();
            return axios.get(bankApi+`bankAgents/getAllAccepted?AgentID=`+userID)
                .then(({data}) => data.response)
                .catch(err => errorHandler.tomcatError(err))
        },
        fetchBanks: (context) => {
          return axios.get(bankApi + 'banks/getAllBanks')
            .then(({data}) => {
              context.commit('setBanks', data.response);
            })
            .catch(err => errorHandler.tomcatError(err));
        },
    },
}
